"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CameraReadiness = require("./CameraReadiness");
Object.keys(_CameraReadiness).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CameraReadiness[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CameraReadiness[key];
    }
  });
});